<div class="smartphones">

    <sc-master-detail [selection]="[selectedSmartphone]" [data]="smartphones" [newStyle]="true"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
        (deleteEntry)="onDeleteEntry($event);">

        <mat-tab-group>

          <mat-tab [label]="'base-data' | translate: ['tmc-common.ui.supplementary-equipment.base-data', translationService.language]">

            <sc-scroll-pane>
                <form class="form" #smartphoneForm="ngForm">
                    <sc-padding>
                        <sc-flex [vertical]="true" [stretchContent]="true" *ngIf="workingCopyDetails"
                            class="no-field-space">
                            <mat-form-field>
                                <input [(ngModel)]="workingCopyDetails.nbr" #ctrlNumber="ngModel" name="nbr" matInput
                                    placeholder="{{'number' | translate: ['tmc.admin.smartphone.number.label', translationService.language]}}"
                                    [required]="true" [maxlength]="255" />
                            </mat-form-field>
                            <sc-content-spacer [vertical]="true"></sc-content-spacer>
                            <mat-form-field>
                                <input [(ngModel)]="workingCopyDetails.serialNbr" name="serialNbr" matInput
                                    placeholder="{{'serial number' | translate: ['tmc.admin.smartphone.serialnumber.label', translationService.language]}}"
                                    [required]="false" [maxlength]="255" />
                            </mat-form-field>
                            <sc-content-spacer [vertical]="true"></sc-content-spacer>
                            <mat-form-field>
                                <textarea [(ngModel)]="workingCopyDetails.hint" name="hint" matInput
                                    placeholder="{{'hint' | translate: ['tmc.admin.smartphone.hint.label', translationService.language]}}"
                                    [required]="false" [maxlength]="1024"></textarea>
                            </mat-form-field>
                            <sc-content-spacer [vertical]="true"></sc-content-spacer>
                            <mat-checkbox [(ngModel)]="workingCopyDetails.available" name="available">
                                {{'available' | translate: ['tmc.admin.smartphone.available.label',
                                translationService.language]}}
                            </mat-checkbox>
                        </sc-flex>
                    </sc-padding>
                </form>
            </sc-scroll-pane>
          </mat-tab>


          <mat-tab [label]="'report' | translate: ['tmc-common.ui.supplementary-equipment.report', translationService.language]">
            <app-equipment-log  [equipmentIdentifier]="equipmentIdentifier"></app-equipment-log>
          </mat-tab>
        </mat-tab-group>

        <ng-template masterDetailToolbar>
            <button mat-stroked-button class="config-changed-button" (click)="cancel()"
                [disabled]="!cancelEnabled">{{'cancel' | translate: ['tmc.admin.smartphone.action.cancel',
                translationService.language]}}</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
                translate: ['tmc.admin.smartphone.action.save',
                translationService.language]}}</button>
        </ng-template>

    </sc-master-detail>

</div>
